import { createFileRoute } from '@tanstack/react-router';
import { ClipsHubPage } from '@/features/clips/clips-hub-page';

export const Route = createFileRoute('/w/$workspaceId/clips/')({ component: ClipsHubPage });
